import { Box } from "@chakra-ui/react";
import { html2pdf } from "html2pdf.js";
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { commonStyle } from "../../styles/commonStyle";

const MarkdownRenderer = ({ content }) => {
  if (!content || typeof content !== "string") {
  console.warn("Invalid content passed to MarkdownRenderer:", content);
  return <div></div>;
}


// 🎯 Extract <html>...</html> directly
const htmlMatch = content.match(/<html[^>]*>[\s\S]*?<\/html>/i);

let htmlContent = null;
if (htmlMatch) {
  htmlContent = htmlMatch[0]
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\r')
    .replace(/\\t/g, '\t')
    .replace(/\\"/g, '"')
    .replace(/\\'/g, "'")
    .replace(/\\\\/g, '\\');
}


// ✂️ Remove <my_graph_code> block entirely from markdown
const markdownContent = content.replace(/<html[^>]*>[\s\S]*?<\/html>/gi, "");
  return (
    <div>
      <ReactMarkdown
        components={{
          strong: ({ node, ...props }) => (
            <strong style={{ color: "black" }} {...props} />
          ),
          p: ({ node, ...props }) => (
            <p style={{ color: "#1E1F22", fontSize: "12px" }} {...props} />
          ),
          code: ({ node, inline, children, ...props }) =>
            inline ? (
              <code
                style={{
                  color: "black",
                  backgroundColor: "#f0f0f0",
                  padding: "2px 4px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "12px",
                }}
                {...props}
              >
                {children}
              </code>
            ) : (
              <pre
                style={{
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "12px",
                  overflowX: "auto",
                  fontSize: "12px",
                  color: "black",
                  margin: "12px 0",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code {...props}>{children}</code>
              </pre>
            ),

          code: ({ node, inline, children, ...props }) =>
            inline ? (
              <code
                style={{
                  color: "black",
                  backgroundColor: "#f0f0f0",
                  padding: "2px 4px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "12px",
                }}
                {...props}
              >
                {children}
              </code>
            ) : (
              <pre
                style={{
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  padding: "12px",
                  overflowX: "auto",
                  fontSize: "12px",
                  color: "black",
                  margin: "12px 0",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code {...props}>{children}</code>
              </pre>
            ),

          ul: ({ node, ...props }) => (
            <ul
              style={{ color: "#1E1F22", marginLeft: "20px", fontSize: "14px" }}
              {...props}
            />
          ),
          ol: ({ node, ...props }) => (
            <ol
              style={{ color: "#1E1F22", marginLeft: "20px", fontSize: "14px" }}
              {...props}
            />
          ),
          li: ({ node, ...props }) => (
            <li style={{ color: "#1E1F22", fontSize: "12px" }} {...props} />
          ),
          table: ({ node, ...props }) => (
            <Box  overflowX= "auto" width= "100%" sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}>
              <table
                style={{
                  width: "100%",
                  minWidth: "600px", // Adjust based on your table's minimum width
                  borderCollapse: "collapse",
                  margin: "20px 0",
                  fontSize: "14px",
                  color: "#1E1F22",
                }}
                {...props}
              />
            </Box>
          ),
          thead: ({ node, ...props }) => (
            <thead
              style={{
                backgroundColor: "#f5f5f5",
                color: "black",
                fontSize: "14px",
                color: "black",
                fontSize: "14px",
              }}
              {...props}
            />
          ),
          tr: ({ node, ...props }) => (
            <tr
              style={{
                // color:"white",
                fontSize: "14px",
                borderBottom: "1px solid #ddd", // optional, you can remove if needed
                // color:"white",
                fontSize: "14px",
                borderBottom: "1px solid #ddd", // optional, you can remove if needed
              }}
              {...props}
            />
          ),
          th: ({ node, ...props }) => (
            <th
              style={{
                padding: "10px",
                textAlign: "left",
                backgroundColor: "#f0f0f0",
              }}
              {...props}
            />
          ),
          td: ({ node, ...props }) => (
            <td
              style={{
                padding: "10px",
                textAlign: "left",
              }}
              {...props}
            />
          ),
        }}
        remarkPlugins={[remarkGfm]}
      >
        {markdownContent}
      </ReactMarkdown>
        {htmlContent && (
              <Box
                width="100%"
                margin="20px 0"
                borderRadius="8px"
                overflow="hidden"
                boxShadow="0 4px 12px rgba(0,0,0,0.1)"
                border="2px solid #e2e8f0"
              >
                <iframe
                  title="Interactive HTML Content"
                  srcDoc={htmlContent}
                  style={{
                    width: "100%",
                    height: "500px",
                    border: "none",
                    display: "block",
                    backgroundColor: "white",
                  }}
                  sandbox="allow-scripts allow-same-origin allow-forms"
                  loading="lazy"
                />
              </Box>
            )}
    </div>
  );
};

export default MarkdownRenderer;



// import { Box } from "@chakra-ui/react";
// import { html2pdf } from "html2pdf.js";
// import React from "react";
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";
// import { commonStyle } from "../../styles/commonStyle";

// const MarkdownRenderer = ({ content }) => {
//   // 🛡️ Safe check
// if (!content || typeof content !== "string") {
//   console.warn("Invalid content passed to MarkdownRenderer:", content);
//   return <div></div>;
// }


// // 🎯 Extract <html>...</html> directly
// const htmlMatch = content.match(/<html[^>]*>[\s\S]*?<\/html>/i);

// let htmlContent = null;
// if (htmlMatch) {
//   htmlContent = htmlMatch[0]
//     .replace(/\\n/g, '\n')
//     .replace(/\\r/g, '\r')
//     .replace(/\\t/g, '\t')
//     .replace(/\\"/g, '"')
//     .replace(/\\'/g, "'")
//     .replace(/\\\\/g, '\\');
// }


// // ✂️ Remove <my_graph_code> block entirely from markdown
// const markdownContent = content.replace(/<html[^>]*>[\s\S]*?<\/html>/gi, "");
//   return (
//     <div>
//       <ReactMarkdown
//         components={{
//           strong: ({ node, ...props }) => (
//             <strong style={{ color: "black" }} {...props} />
//           ),
//           p: ({ node, ...props }) => (
//             <p style={{ color: "#1E1F22", fontSize: "12px" }} {...props} />
//           ),

//           code: ({ node, inline, children, ...props }) =>
//             inline ? (
//               <code
//                 style={{
//                   color: "black",
//                   backgroundColor: "#f0f0f0",
//                   padding: "2px 4px",
//                   borderRadius: "4px",
//                   border: "1px solid #ccc",
//                   fontSize: "12px",
//                 }}
//                 {...props}
//               >
//                 {children}
//               </code>
//             ) : (
//               <pre
//                 style={{
//                   backgroundColor: "#f0f0f0",
//                   border: "1px solid #ccc",
//                   borderRadius: "8px",
//                   padding: "12px",
//                   overflowX: "auto",
//                   fontSize: "12px",
//                   color: "black",
//                   margin: "12px 0",
//                   whiteSpace: "pre-wrap",
//                   wordBreak: "break-word",
//                 }}
//               >
//                 <code {...props}>{children}</code>
//               </pre>
//             ),

//           ul: ({ node, ...props }) => (
//             <ul
//               style={{ color: "#1E1F22", marginLeft: "20px", fontSize: "14px" }}
//               {...props}
//             />
//           ),
//           ol: ({ node, ...props }) => (
//             <ol
//               style={{ color: "#1E1F22", marginLeft: "20px", fontSize: "14px" }}
//               {...props}
//             />
//           ),
//           li: ({ node, ...props }) => (
//             <li style={{ color: "#1E1F22", fontSize: "12px" }} {...props} />
//           ),
//           table: ({ node, ...props }) => (
//             <Box  overflowX= "auto" width= "100%" sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   minWidth: "600px", // Adjust based on your table's minimum width
//                   borderCollapse: "collapse",
//                   margin: "20px 0",
//                   fontSize: "14px",
//                   color: "#1E1F22",
//                 }}
//                 {...props}
//               />
//             </Box>
//           ),
//           thead: ({ node, ...props }) => (
//             <thead
//               style={{
//                 backgroundColor: "#f5f5f5",
//                 color: "black",
//                 fontSize: "14px",
//                 color: "black",
//                 fontSize: "14px",
//               }}
//               {...props}
//             />
//           ),
//           tr: ({ node, ...props }) => (
//             <tr
//               style={{
//                 // color:"white",
//                 fontSize: "14px",
//                 borderBottom: "1px solid #ddd", // optional, you can remove if needed
//                 // color:"white",
//                 fontSize: "14px",
//                 borderBottom: "1px solid #ddd", // optional, you can remove if needed
//               }}
//               {...props}
//             />
//           ),
//           th: ({ node, ...props }) => (
//             <th
//               style={{
//                 padding: "10px",
//                 textAlign: "left",
//                 backgroundColor: "#f0f0f0",
//               }}
//               {...props}
//             />
//           ),
//           td: ({ node, ...props }) => (
//             <td
//               style={{
//                 padding: "10px",
//                 textAlign: "left",
//               }}
//               {...props}
//             />
//           ),
//         }}
//         remarkPlugins={[remarkGfm]}
//       >
//         {/* {content} */}
//         {markdownContent}
//       </ReactMarkdown>
//         {htmlContent && (
//               <Box
//                 width="100%"
//                 margin="20px 0"
//                 borderRadius="8px"
//                 overflow="hidden"
//                 boxShadow="0 4px 12px rgba(0,0,0,0.1)"
//                 border="2px solid #e2e8f0"
//               >
//                 <iframe
//                   title="Interactive HTML Content"
//                   srcDoc={htmlContent}
//                   style={{
//                     width: "100%",
//                     height: "500px",
//                     border: "none",
//                     display: "block",
//                     backgroundColor: "white",
//                   }}
//                   sandbox="allow-scripts allow-same-origin allow-forms"
//                   loading="lazy"
//                 />
//               </Box>
//             )}
//     </div>
//   );
// };

// export default MarkdownRenderer;
